module.exports = __webpack_public_path__ + "img/liveTimeDownloadBtn.8da06d86.png";